module.exports = __webpack_public_path__ + "img/absurd-por-que.443e1bf9.png";